<nz-skeleton-element
  nzType="input"
  nzSize="small"
  style="width: 20%"
  [nzActive]="true"
  class="mb-24"
></nz-skeleton-element>

<app-item-skeleton
  *ngFor="let item of items; let i = index"
  [class.mt-20]="i > 0"
></app-item-skeleton>
